import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Router } from '@angular/router';
import { AppConfig } from '@app/app.config';
import { appConfigToken } from '@app/app.config.token';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export let browserRefresh = false;

if (environment.production) {
  enableProdMode();
}

let appConfigFile = 'app.config.json';
if (window.location.hostname.includes('localhost')) {
  appConfigFile = 'app.config.local.json';
} else if (window.location.hostname.includes('-dev')) {
  appConfigFile = 'app.config.dev.json';
} else if (window.location.hostname.includes('-qa')) {
  appConfigFile = 'app.config.qa.json';
} else if (window.location.hostname.includes('-stage')) {
  appConfigFile = 'app.config.stage.json';
} else if (window.location.hostname.includes('payer.labcorp.com')) {
  appConfigFile = 'app.config.prod.json';
}


fetch('assets/environment/' + appConfigFile)
  .then(response => response.json())
  .then((appConfig: AppConfig) => {

    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic([
      { provide: appConfigToken, useValue: appConfig },
      {
        provide: OKTA_CONFIG,
        useFactory: () => {
          const oktaAuth = new OktaAuth(appConfig.oidc);
          OktaAuthModule.forRoot({ oktaAuth });
          return {
            oktaAuth,
            onAuthRequired: (oktaAuth: OktaAuth, injector: Injector) => {

              const triggerLogin = () => {
                // Redirect the user to your custom login page
                const router = injector.get(Router);
                router.navigate(['/login']);
              };

              if (!oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated) {
                // App initialization stage
                triggerLogin();
              } 
            }
          }
        }
      }
    ])
      .bootstrapModule(AppModule).then(() => {
        browserRefresh = true;
        if (window.location.href.indexOf('/login') ===-1) {
          sessionStorage.setItem('originUrl', window.location.href);
        }
      })
      .catch(err => console.error(err));
  });


export function resetBrowser() {
  browserRefresh = false;
}
